<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 10:21:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-23 17:03:11
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="12">
            <mrc_ess_viewbtn :is_used="list.send_stat_save_value"
                             :label="list.send_stat"></mrc_ess_viewbtn>
          </v-col>
          <!-- <v-col cols="12"
                 sm="6">
            <mrc_ess_input :label="$t('创建人') + '*'"
                           :value="INT(list.updated_by)"
                           :disabled="true"
                           :readonly="disabled">
            </mrc_ess_input>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_datePicker :label="$t('创建时间') + '*'"
                                :disabled="true"
                                v-model="list.created_utc_datetime">
            </mrc_ess_datePicker>
          </v-col> -->
          <v-col cols="12"
                 sm="6">
            <!-- <mrc_ess_multiText :label="$t('label_The_customer_name')+'*'"
                               v-model="client_name"
                               :readonly="true">
            </mrc_ess_multiText> -->
            <!-- <mrc_ess_prompt :disabled="true"
                          :label="$t('label_The_customer_name')+'*'"
                          :obj='companyToClient'
                          v-model="client_uuid"></mrc_ess_prompt> -->
            <!-- <mrc_ess_multiText :label="$t('label_The_customer_name')+'*'"
                               v-model="list.client_uuid"
                               :isNational="judegNational('client_uuid')"
                               :readonly="true">
            </mrc_ess_multiText> -->
            <mrc_ess_input :label="$t('label_The_customer_name') + '*'"
                           :value="INT(list.client_uuid)"
                           :disabled="true"
                           :readonly="disabled">
            </mrc_ess_input>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_input :label="$t('label_company_name') + '*'"
                           :value="INT(list.org_level_uuid)"
                           :disabled="true"
                           :readonly="disabled">
            </mrc_ess_input>
            <!-- <mrc_ess_multiText :label="$t('label_company_name')+'*'"
                               v-model="list.org_level_uuid"
                               :isNational="judegNational('org_level_uuid')"
                               :readonly="true">
            </mrc_ess_multiText> -->
            <!-- <mrc_ess_prompt :disabled="true"
                            value_field='uuid'
                            :label="$t('label_company_name')+'*'"
                            obj='org_level_for_clients'
                            v-model="list.org_level_uuid"></mrc_ess_prompt> -->
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="this.$t('label_Sender')"
                               v-model="list.smtp_username"
                               :disabled="true"
                               :readonly="true">
            </mrc_ess_multiText>
          </v-col>
          <!-- template_code 和 failure_reason -->
          <v-col cols="12">
            <!-- 模板编码 -->

            <!-- <mrc_ess_dictName
              v-model="list.template_code"
              :disabled="true"
              :label="$t('label_template_code')"
              dict_name="MailTempldateCode"
              :readonly="true"
            ></mrc_ess_dictName> -->
            <mrc_ess_autoComplete v-if="list.send_stats == 2"
                                  itemText="dict_label"
                                  itemValue="dict_value"
                                  :label="$t('label_templateCode')"
                                  :readonly="true"
                                  :disabled="true"
                                  v-model="list.template_code"
                                  dict_name="MailTempldateCode">
            </mrc_ess_autoComplete>
          </v-col>
          <v-col cols="12">
            <!-- 错误理由 -->
            <mrc_ess_multiTextarea v-if="list.send_stats == 2"
                                   textarea
                                   :label="this.$t('label_failure_reason')"
                                   v-model="list.failure_reason"
                                   :disabled="true"
                                   :readonly="disabled">
            </mrc_ess_multiTextarea>
          </v-col>

          <v-col cols="12">
            <mrc_ess_multiText :label="this.$t('label_The_recipient')"
                               v-model="list.addressee"
                               :readonly="disabled">
            </mrc_ess_multiText>
            <!-- <mrc_ess_autoCompleteEmailTemplate v-model="showlist"
                                             itemKey='staff_email'
                                             :disabled='disabled'
                                             :label="$t('label_The_recipient')"
                                             placeholder=" "
                                             @closeChipProperty='closeChipProperty'
                                             :propertylist='propertylist'
                                             multiple></mrc_ess_autoCompleteEmailTemplate> -->

            <!-- <propertyDialog :readonly='!disabled'
                          :function_uuid='updateFunction_uuid'
                          @getpropertylist='getpropertylist'></propertyDialog> -->
          </v-col>
          <!-- <v-col cols="12">
          副本副本副本副本副本副本
          <mrc_ess_autoCompleteEmailTemplate v-model="deputyshowlist"
                                             itemKey='staff_email'
                                             :disabled='disabled'
                                             :label="$t('label_Deputy_to_the_addressee')"
                                             placeholder=" "
                                             @closeChipProperty='closeChipProperty2'
                                             :propertylist='deputypropertylist'
                                             multiple></mrc_ess_autoCompleteEmailTemplate>
          <propertyDialog :readonly='!disabled'
                          :function_uuid='updateFunction_uuid'
                          @getpropertylist='getpropertylist'></propertyDialog>
        </v-col> -->
          <v-col cols="12"
                 style="position:relative">
            <!-- <inputtemplate v-model="emailsubject"
                         :readonly='disabled'
                         :function_uuid='updateFunction_uuid'></inputtemplate> -->
            <mrc_ess_input :label="$t('label_Email_message')"
                           :rules="rules"
                           class="my-0 py-0"
                           :readonly="disabled"
                           v-model="list.mail_title">
            </mrc_ess_input>
          </v-col>
          <v-col cols="12"
                 class="textBox">
            <!-- append-icon="mdi-longitude" -->
            <!-- <v-textarea v-model="list.mail_content"
                        :background-color="!disabled?'rgb(2242, 242, 242)':'#fff'"
                        rows="10"
                        :readonly='disabled'
                        :label=" $t('label_The_mail_text')"></v-textarea> -->
            <editor :menuShow="true"
                    :readonly="disabled"
                    :overflow="false"
                    height="100vh"
                    name="qwert"
                    :label="$t('label_The_mail_text')"
                    @changeContent="
                (val) => {
                  list.mail_content = val
                }
              "
                    :content="list.mail_content">
            </editor>
            <!-- <editor v-else
                    :menuShow='false'
                    :readonly='false'
                    :overflow='false'
                    height="100vh"
                    name="qwert"
                    :label="$t('label_The_mail_text')"
                    :content="list.mail_content"></editor> -->
          </v-col>
        </v-row>
      </v-card-text>
      <template v-if="$store.state.uuid">
        <mrc_ess_submitBtn @cancel="cancel"
                           @success="success"
                           v-if="!disabled"></mrc_ess_submitBtn>
      </template>
      <template v-else>
        <mrc_ess_submitBtn @cancel="addcancel"
                           @success="addsuccess"
                           :cancelText="$t('label_The_previous_step')"
                           v-if="!disabled"></mrc_ess_submitBtn>
      </template>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  historyMailList,
  historyMailDetails,
  historyEmailUpdate,
  historyMailResend,
} from "@/service/api/historyMail.js"
import { getBusinessList } from "@/service/api/prompt.js"
import propertyDialog from "./modules/propertyDialog"
import textareatemplate from "./modules/textareatemplate"
import editor from "./modules/editor.vue"
import inputtemplate from "./modules/inputtemplate"
export default {
  components: {
    propertyDialog,
    textareatemplate,
    inputtemplate,
    editor,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    function_uuid: {
      type: String,
    },
  },
  data () {
    return {
      skeletonloading: true,
      rules: [(value) => !!value || "Required."],
      client_name: "",
      showlist: "", //收件人
      propertylist: [], //收件人功能变量
      deputyshowlist: "", //副收件人
      deputypropertylist: [], //副收件人功能变量
      emailsubject: [],
      emailcontent: [],
      list: {
        mail_content: "",
      },
      dialog: false,
      updateFunction_uuid: "",
    }
  },
  computed: {
    // org_name () {
    //   return this.INT(this.list.org_level_uuid)
    // },
    // client_uuid () {
    //   return this.INT(this.list.client_uuid)
    // },
    companyToClient () {
      return {
        prompt_name: "companyToClient",
        org_level_uuid: this.list.org_level_uuid,
      }
    },
  },
  created () { },
  watch: {
    function_uuid (v) {
      if (!this.$store.state.uuid) {
        this.updateFunction_uuid = this.function_uuid
      }
    },
  },
  async mounted () {
    this.national("mrbase_sys_mail_send")
    if (this.$store.state.uuid) {
      await this.getdetail()
      // getBusinessList(this.companyToClient).then(res => {
      //   this.client_name = this.INT(res.data[0].view_fields)
      // })
    } else {
      this.updateFunction_uuid = this.function_uuid
    }
  },

  methods: {
    async getdetail () {
      this.skeletonloading = true
      const res = await historyMailDetails({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
        // const propertylist = []
        // res.data.template_carbon_copy = res.data.template_carbon_copy + ',{{ijjjj}},{{sasxx}}'
        // res.data.addressee = '1804489370@qq.com,{{saaas}},{{qqqws}}'
        // // 主收件人
        const propertylist = []
        const showlist = []
        const deputypropertylist = []
        let deputyshowlist = []
        const emailsubject = []
        const emailcontent = []
        // this.updateFunction_uuid = res.data.function_uuid
        if (res.data.addressee.indexOf(",") != -1) {
          res.data.addressee.split(",").map((item) => {
            if (item.indexOf("{{") == 0) {
              propertylist.push({ property: item, divbgd: true })
            } else {
              showlist.push(item)
            }
          })
        } else {
          if (res.data.addressee.indexOf("{{") == 0) {
            propertylist.push({ property: res.data.addressee, divbgd: true })
          } else {
            showlist.push(res.data.addressee)
          }
        }
        // 副收件人
        // if (res.data.template_carbon_copy.indexOf(',') != -1) {
        //   res.data.template_carbon_copy.split(',').map(item => {
        //     if (item.indexOf('{{') == 0) {
        //       deputypropertylist.push({ 'property': item, 'divbgd': true })
        //     }
        //     else {
        //       deputyshowlist.push(item)
        //     }
        //   })
        // }
        // else {
        //   if (res.data.template_carbon_copy.indexOf('{{') != -1) {
        //     deputypropertylist.push({ 'property': res.data.template_carbon_copy, 'divbgd': true })
        //   }
        //   else {
        //     deputyshowlist.push(res.data.template_carbon_copy)
        //   }
        // }
        // 主旨和内容
        // res.mrbase_sys_mail_template_language.map(item => {
        //   if (item.content_type == 1) {
        //     item.content = item.content.replace(/<br\/>/g, "\n")
        //     emailsubject.push(item)
        //   }
        //   if (item.content_type == 2) {
        //     item.content = item.content.replace(/<br\/>/g, "\n")
        //     emailcontent.push(item)
        //   }
        // })
        // ----主副收件人---------------
        this.propertylist = propertylist
        this.showlist = showlist.join()
        this.deputyshowlist = deputyshowlist.join()
        this.deputypropertylist = deputypropertylist
        // ----主旨 ---内容-----
        this.emailsubject = emailsubject
        this.emailcontent = emailcontent
      }
      this.skeletonloading = false
    },
    async cancel () {
      this.$emit("changeReadonly")
      this.getdetail()
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit')

      // }).then(res => {
      //   this.$router.push({
      //     name: 'emailtemplate'
      //   })
      // }).catch(err => { })
    },
    datatreating () {
      let showlist = this.showlist
      this.propertylist.map((item) => {
        showlist
          ? (showlist += "," + item.property)
          : (showlist += item.property)
      })

      let deputyshowlist = this.deputyshowlist
      this.deputypropertylist.map((item) => {
        deputyshowlist
          ? (deputyshowlist += "," + item.property)
          : (deputyshowlist += item.property)
      })

      let emailsubject = this.$clone(this.$deletefield(this.emailsubject)).map(
        (item) => {
          item.content.replace(/\n/g, "<br/>")
          return item
        }
      )
      let emailcontent = this.$clone(this.$deletefield(this.emailcontent)).map(
        (item) => {
          item.content = item.content.replace(/\n/g, "<br/>")
          return item
        }
      )

      // console.log(emailsubject, emailcontent)
      // return
      let mrbase_sys_mail_template_language = [...emailsubject, ...emailcontent]
      mrbase_sys_mail_template_language = mrbase_sys_mail_template_language.map(
        (item) => {
          delete item.id
          delete item.template_uuid
          return item
        }
      )
      // console.log(this.deputyshowlist);
      // console.log(this.deputypropertylist);
      // console.log(this.emailsubject);
      // console.log(this.emailcontent);
      // console.log(mrbase_sys_mail_template_language);
      return {
        mrbase_sys_mail_template_language,
        addressee: showlist,
        template_carbon_copy: deputyshowlist,
      }
    },
    success () {
      historyEmailUpdate(this.$deletefield(null, this.list)).then((res) => {
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          })
          this.$emit("changeReadonly")
          this.getdetail()
        }
      })
    },
    addcancel () {
      this.$emit("changee1", 1)
    },
    addsuccess () {
      this.$emit("submit", this.datatreating())
    },
    getpropertylist (v) {
      this.propertylist.push(...v)
      this.propertylist = this.arrDeduplication(this.propertylist)
    },
    deputygetpropertylist (v) {
      this.deputypropertylist.push(...v)
      this.deputypropertylist = this.arrDeduplication(this.deputypropertylist)
    },
    closeChipProperty (val, index) {
      this.propertylist.splice(index, 1)
    },
    closeChipProperty2 (val, index) {
      this.deputypropertylist.splice(index, 1)
    },
    arrDeduplication (arr) {
      //数组去重
      let newobj = {}
      let arrs = []
      arrs = arr.reduce((preVal, curVal) => {
        newobj[curVal.property]
          ? ""
          : (newobj[curVal.property] = preVal.push(curVal))
        return preVal
      }, [])
      return arrs
    },
    reSend () {
      this.$myConfirm({ content: this.$t("label_confirm_to_resend") })
        .then((res) => {
          historyMailResend({ uuid: this.$store.state.uuid }).then((res) => {
            if (res.code === "200") {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              this.$router.push({ name: "historyMail" })
            }
          })
        })
        .catch((err) => { })
    },
  },
}
</script>

<style scoped>
.box /deep/ .v-text-field__details {
  min-height: 0px;
}
.box /deep/ .v-messages {
  min-height: 0px;
  height: 0px;
}
.textBox /deep/ textarea {
  text-indent: 8px;
}
</style>
